<template>
  <div id="bottom-nav-empty-space">
    <div id="bottom-navbar" class="container">
      <div class="bar-links">

        <div class="left-bar">
          <div v-for="item in barItems" :key="item.name">
            <router-link :to="item.path" class="bar-link">
              <img 
                :src="require(`@/assets/imgs/icons/navbar/${getIconPath(item)}.svg`)"
              />
              <!-- {{ item.name }} -->
            </router-link>
          </div>
        </div>


        <div class="right-bar">
          <button class="bar-link" @click="toggleSidebar">
            <img 
              :src="require(`@/assets/imgs/icons/navbar/hamburger.svg`)"
            />
          </button>
        </div>
      </div>
    </div>

    <div class="sidebar" :class="{ open: sidebarOpen }">
      <button class="close-button" @click="toggleSidebar">X</button>
      <div class="sidebar-content nav-links">
        <div v-for="item in menuItems" :key="item.name">
          <router-link :to="item.path" class="nav-link" @click="toggleSidebar">
            {{ item.name }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue'
  import { useRoute } from 'vue-router'

  // stato
  const sidebarOpen = ref(false)

  // MENU ITEMS
  const barItems = [
    { name: 'Home', path: '/', icon: 'home' },
    { name: 'Tornei (beta)', path: '/tournament', icon: 'battle' },
    { name: 'Account', path: '/account', icon: 'user' },
  ]

  const menuItems = [
    { name: '📌 Registra i tuoi Beyblade', path: '/register-your-beys' },
    { name: '📃 Regolamento', path: '/rules' },
    { name: '🏆 Tornei (beta)', path: '/tournament' },
    { name: '🔀 Beyblade Casuali', path: '/randomizer' },
    { name: '🚫 Torneo Ban', path: '/tournament-ban' },
  ]

  // route attuale
  const route = useRoute()
  const currentPath = computed(() => route.path)

  // metodi
  function getIconPath(item) {
    const isSelected = currentPath.value === item.path
    const iconName = isSelected ? `${item.icon}-selected` : item.icon
    return iconName
  }

  function toggleSidebar() {
    sidebarOpen.value = !sidebarOpen.value
  }
</script>

<style scoped lang="scss">
#bottom-nav-empty-space {
  height: 100px;
}
@import './bottom-nav-bar.scss';
</style>